import { useMatch } from 'react-router-dom';
import SearchBarTrigger from './SearchBarTrigger';
import LocationListContainer from './LocationListContainer';
import YettelMenu from './YettelMenu';
import HeaderProfile from './HeaderProfile';
import { YETTEL_MENU_ITEMS } from '../utils/menu';
import DesktopNavigation from './DesktopNavigation';
import '../scss/yettel-header.scss';

interface Props {
  navigateToHomepage: () => void;
}

const HeaderDesktop: React.FC<Props> = ({ navigateToHomepage }) => {
  const isHomePage = useMatch('/');
  const isPrivacyPage = useMatch('/profil/privatnost');

  return (
    <header
      className={`yettel-header bg-light-blue ${!isHomePage ? '' : 'has-skirt'}`}
    >
      <div className="yettel-header__container container d-flex align-items-center">
        <div className="yettel-header__logo-container">
          <div className="cursor-pointer" onClick={() => navigateToHomepage()}>
            <span className="d-block color-dark-blue font-yettel-bold">
              Y. Shopping
            </span>
          </div>
        </div>

        {!isPrivacyPage && <DesktopNavigation />}

        <div className="yettel-header__searchbar-container">
          {isHomePage && <LocationListContainer />}
          <SearchBarTrigger />
        </div>
        <div
          style={{ marginLeft: '5px' }}
          className="d-flex align-items-center"
        >
          <YettelMenu menuItems={YETTEL_MENU_ITEMS} />
          <HeaderProfile />
        </div>
      </div>
    </header>
  );
};

export default HeaderDesktop;
